import { Injectable } from '@angular/core';

@Injectable()
export class TooltipService {
    public static hideTooltip() {
        jQuery(".ui-tooltip").remove();
    }
}